<!-- This icon is for accessible checkboxes only, and is not considered an "Icon" by the design team -->
<svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke={$$props.currentColor} {...$$props}>
  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
</svg>
